<div class="modal-body text-center">
    <p>{{message}}</p>
    <button type="button" class="btn btn-default mr-2" (click)="confirm()">Si</button>
    <button type="button" class="btn btn-default ml-2" (click)="decline()">No</button>
</div>